module.exports = __webpack_public_path__ + "9a75ee2dc720159f18241f8794d41c93.MP3";